module.exports = __webpack_public_path__ + "static/media/S33_black.77542dac.png";